import { LazyMotion, domAnimation } from "framer-motion";

/**
 * Loads only the DOM animation feature bundle (~60% smaller than full framer-motion).
 * All motion primitives must render inside this provider.
 */
function MotionProvider({ children }) {
  return (
    <LazyMotion features={domAnimation} strict>
      {children}
    </LazyMotion>
  );
}

export default MotionProvider;
